export default "__VITE_ASSET__6dba7433__"